
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { usePortalMessageStore } from '@/store/portalMessages';

    import { Error } from '@progress/kendo-vue-labels'
    import Loader from '@/components/common/loader.vue'

    import { ILinkDTO } from '@/types/ILinkDTO'
    import { StringUtil } from '@/util';

    export default defineComponent({
        name: 'loginContent',

        components: {
            Loader,
            Error
        },

        props: {
            title: { type: String as PropType<string>, required: true },
            inProgress: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            errorMessage: { type: String as PropType<string | null>, required: false, default: () => null },
            links: { type: Array as PropType<ILinkDTO[]>, required: false, default: () => [] }
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const portalMessageStore = usePortalMessageStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = {}

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const maintenanceMessage = computed(() => portalMessageStore.maintenanceMessage)
            const isMaintenanceMode = computed(() => StringUtil.hasContent(maintenanceMessage.value))

            const computedData = { maintenanceMessage, isMaintenanceMode }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const publicMethods = {}

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
